module.exports = __webpack_public_path__ + "img/close.cb0a8adc.svg";